module.exports = __webpack_public_path__ + "4.dd77cc9a389082233e62.png";


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/assets/styles/patterns/4.png
// module id = ../../../../../src/assets/styles/patterns/4.png
// module chunks = 1